// Presentation only: keep the stored identity unchanged.
export const formatUserName = value => String(value ?? '').trim().replace(/\s+/g,' ')
  .toLocaleLowerCase('es')
  .replace(/(^|[\s,\-’'])\p{L}/gu, part => part.toLocaleUpperCase('es'));
